module.exports = __webpack_public_path__ + "static/media/Uebersetzungen.3349163d.png";